import { qs, qsa, add, remove } from "@fluorescent/dom";
import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  partial: "[data-partial]",
  items: `
    .search-template__heading > *:not(.animation--item-revealed),
    .search-template__filter-buttons:not(.animation--item-revealed),
    .search-template__top-row:not(.animation--item-revealed),
    .search-template__item:not(.animation--item-revealed),
    .search-template__pagination:not(.animation--item-revealed)
  `,
};

const classes = {
  hideItems: "animation--search-items-hide",
  itemRevealed: "animation--item-revealed",
};

export default node => {
  if (!shouldAnimate(node)) return;
  const observer = intersectionWatcher(node);
  const partial = qs(selectors.partial, node);

  setupDelays();

  function setupDelays() {
    const items = qsa(selectors.items, node);
    delayOffset(node, [selectors.items], 1);
    setTimeout(() => {
      add(items, classes.itemRevealed);
    }, 50);
  }

  function updateContents() {
    setupDelays();
    // Remove the fade out class
    remove(partial, classes.hideItems);
  }

  return {
    updateContents,
    destroy() {
      observer?.destroy();
    },
  };
};
